<template>
    <el-menu-item v-if="item.children.length === 0" :index="item.url" @click="$emit('select')">
        <img :src="item.menu_icon" :alt="item.menu_icon" />
        {{ item.title }}
    </el-menu-item>
    <el-submenu v-else :index="item.url" class="sub-menu-list" :popper-append-to-body="false">
        <template slot="title">
            <img :src="item.menu_icon" :alt="item.menu_icon" />
            {{ item.title }}
        </template>
        <template v-for="child in item.children">
            <tree-menu v-if="child.children && child.children.length>0" :item="child" :key="child.id"></tree-menu>
            <el-menu-item v-else :index="child.url" v-bind:key="child.id" @click="$emit('select')">
                <img :src="child.menu_icon" :alt="child.menu_icon" />
                {{ child.title }}
            </el-menu-item>
        </template>
    </el-submenu>
</template>
<script>
    export default {
        props: {
            item: {
                type: Object,
                required: true
            }
        },
        name: "tree-menu",
        data() {
            return {
                onlyOneChild: null
            };
        }
    };

</script>



// WEBPACK FOOTER //
// src/components/Layout/TopNav/TreeMenu.vue